export const environment = {
  production: true,
  env: 'production',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  API_URL: 'https://api.homhero.com.au/',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PCI_URL: 'https://secure.homhero.com.au/pci',
};
